export const filterParamsActions = {
  handleNameParam: ({ commit }: { commit: Function }, payload: string) => {
    commit("setNameParam", payload);
  },
  handleClaimNumberParam: ({ commit }: { commit: Function }, payload: string) => {
    commit("setClaimNumberParam", payload);
  },
  handleClaimStatusParam: ({ commit }: { commit: Function }, payload: string[]) => {
    commit("setClaimStatusParam", payload);
  },
  handleDateParam: ({ commit }: { commit: Function }, payload: string) => {
    commit("setDateParam", payload);
  },
  handleLocationCodeParam: ({ commit }: { commit: Function }, payload: string[]) => {
    commit("setLocationCodeParam", payload);
  },
  handleLossTypeParam: ({ commit }: { commit: Function }, payload: string[]) => {
    commit("setLossTypeParam", payload);
  },
  handleResetFilterParams: async({ commit, dispatch }: { commit: Function, dispatch: Function }) => {
    await commit("resetFilterParams");
    await dispatch("getTPPClaims");
  }
};
